import getNextUserAgent from '@utils/ua/get-user-agent';
import isServer from '@utils/env/is-server';

/**
 * 是否腾讯安全扫描
 * @param ctx
 */
export default function isTencentSecurityScan(ctx?: any) {
  // nodeJS扫描，header有标识
  // request.headers['Tencent-LeakScan'] || request.headers['tencent-leakscan']
  // TST(Tencent Security Team)
  if (isServer) {
    const securityScanHeader =
      ctx?.req?.headers['Tencent-LeakScan'] || ctx?.req?.headers['tencent-leakscan'] || '';
    return securityScanHeader === 'TST(Tencent Security Team)';
  }
  // web客户端
  const userAgent = getNextUserAgent(ctx);
  const isScan = userAgent && userAgent.indexOf('TST(Tencent_Security_Team)') > -1;
  if (isScan) {
    console.log('TencentSecurityScan----', userAgent);
  }
  return isScan;
}
